/**
 * The workspace is in the address (ADR 0052): `/w/<workspace id>/<tab>`. The sign-in says who you are; the address says
 * which business this tab is in, so two tabs in one browser can be in two businesses, a reload stays where it was, and
 * a copied link opens the workspace it was copied in.
 */
// Any segment: the API decides whether it is a workspace this person may open (`mayWorkIn`), and answers 409 when not.
const PREFIX = /^\/w\/([^/]+)(?=\/|$)/;

/** The workspace an address names, or none: `/`, an email link, a bookmark from before 2026-09-25. */
export const workspaceOfPath = (pathname: string): string | undefined => PREFIX.exec(pathname)?.[1];

/** The address without its workspace: `/w/<id>/studio` → `/studio`, and `/w/<id>` → `/`. */
export const pathInWorkspace = (pathname: string): string => pathname.replace(PREFIX, "") || "/";

/** An address in a workspace: `inWorkspace("…", "/studio")` → `/w/…/studio`. */
export const inWorkspace = (workspaceId: string, path = "/"): string => `/w/${workspaceId}${path === "/" ? "" : path}`;
